var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaignIndicator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.352,
    height: 47.277,
    viewBox: "0 0 84.352 47.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_986",
    "data-name": "Pfad 986",
    d: "M4396.333,12308.4l-4.508,4.508a6.378,6.378,0,0,1-4.507,1.867H4326.73a6.372,6.372,0,0,1-4.507-1.867l-4.508-4.508a6.37,6.37,0,0,1-1.867-4.508v-23.514a6.37,6.37,0,0,1,1.867-4.507l4.508-4.508a6.371,6.371,0,0,1,4.507-1.866l60.163.424a6.372,6.372,0,0,1,4.506,1.867l4.509,4.508a6.375,6.375,0,0,1,1.866,4.507l.426,23.089A6.378,6.378,0,0,1,4396.333,12308.4Z",
    transform: "translate(-4314.848 -12268.497)",
    fill: "none",
    stroke: "#0cf",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignIndicator);
export default __webpack_public_path__ + "static/media/campaign-indicator.09e25c6f.svg";
export { ForwardRef as ReactComponent };